module.exports = __webpack_public_path__ + "img/errorHouse.d612315c.png";